(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["demo-pdp-callout"] && !Shopify.designMode) return;
  try {
    (function () {
    var callouts = document.querySelectorAll('.demo-pdp-callout');
    if (!callouts.length) return;

    function update() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
      var qty = input ? parseInt(input.value, 10) || 1 : 1;
      callouts.forEach(function (el) {
        el.hidden = qty < parseInt(el.getAttribute('data-min-quantity'), 10);
      });
    }

    ['input', 'change', 'click'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e.target.closest('input[name="quantity"], quantity-selector-component, .quantity-selector')) {
          requestAnimationFrame(update);
        }
      });
    });

    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
